import uniq from 'lodash/uniq';

import {
    FREE_FACIAL_DEFAULT_VALUES,
    FREE_FACIAL_DEFAULT_PROPOSALS_COUNT,
    FREE_FACIAL_PROPOSAL_QUANTITY,
    FREE_FACIAL_PROPOSAL_EXPIRATION_DATE
} from '../constants/ebon';

// montant achetable : entre le mini et le maxi, et sans centimes si le marchand ne les accepte pas
const isAllowed =
    ({ minimum, maximum, centsAllowed }) =>
    value =>
        value >= minimum && value <= maximum && (centsAllowed || Number.isInteger(value));

// répartit les montants sur toute la plage plutôt que de ne garder que les plus petits
const pickEvenlySpread = (values, count) => {
    if (values.length <= count) {
        return values;
    }
    const step = (values.length - 1) / (count - 1);
    return Array.from({ length: count }, (_, index) => values[Math.round(index * step)]);
};

const toProposal = facialValue => ({
    facialValue,
    quantityAvailable: FREE_FACIAL_PROPOSAL_QUANTITY,
    expirationDate: FREE_FACIAL_PROPOSAL_EXPIRATION_DATE
});

/**
 * Montants proposés sous le champ de saisie de la valeur libre : toutes les valeurs faciales remontées
 * par l'API lorsqu'il y en a, sinon quelques valeurs par défaut. Toujours compris entre le mini et le
 * maxi du marchand, bornes incluses, et sans tenir compte du stock (le bon est généré à la demande).
 */
export const getFreeFacialValueProposals = (availabilityResponses = [], freeFacialConfig) => {
    const allowed = isAllowed(freeFacialConfig);
    const apiValues = uniq(availabilityResponses.map(ebon => ebon.facialValue).filter(allowed));

    const values =
        apiValues.length > 0
            ? apiValues.sort((a, b) => a - b)
            : pickEvenlySpread(
                  FREE_FACIAL_DEFAULT_VALUES.filter(allowed),
                  FREE_FACIAL_DEFAULT_PROPOSALS_COUNT
              );

    return values.map(toProposal);
};



// WEBPACK FOOTER //
// ./src/utils/freeFacialValueUtils.js